"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TabTrigger_exports = {};
__export(TabTrigger_exports, {
  TabTrigger: () => TabTrigger,
  isTabTrigger: () => isTabTrigger,
  useTabTrigger: () => import_useTabTrigger2.useTabTrigger
});
module.exports = __toCommonJS(TabTrigger_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_Link = require("../link/Link");
var import_useTabTrigger = require("./useTabTrigger");
var import_useTabTrigger2 = require("./useTabTrigger");
function TabTrigger(param) {
  var { asChild, name, href, resetOnFocus, ...props } = param;
  var _ref;
  var { trigger, triggerProps } = (0, import_useTabTrigger.useTabTrigger)({
    name,
    resetOnFocus,
    ...props
  });
  var resolvedHref = (_ref = trigger === null || trigger === void 0 ? void 0 : trigger.resolvedHref) !== null && _ref !== void 0 ? _ref : href;
  if (!resolvedHref) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("button", {
      type: "button",
      onClick: function onClick(event) {
        var _triggerProps_onPress;
        return (_triggerProps_onPress = triggerProps.onPress) === null || _triggerProps_onPress === void 0 ? void 0 : _triggerProps_onPress.call(triggerProps, event);
      },
      children: props.children
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Link.Link, {
    ...props,
    href: resolvedHref,
    asChild,
    onPress: function onPress(event) {
      var _triggerProps_onPress;
      if (!(0, import_useTabTrigger.shouldHandleMouseEvent)(event)) return;
      event.preventDefault();
      (_triggerProps_onPress = triggerProps.onPress) === null || _triggerProps_onPress === void 0 ? void 0 : _triggerProps_onPress.call(triggerProps, event);
    },
    onLongPress: triggerProps.onLongPress,
    "aria-current": (trigger === null || trigger === void 0 ? void 0 : trigger.isFocused) ? "page" : void 0,
    ...asChild ? {
      isFocused: Boolean(trigger === null || trigger === void 0 ? void 0 : trigger.isFocused)
    } : null,
    children: props.children
  });
}
function isTabTrigger(child) {
  return child.type === TabTrigger;
}
//# sourceMappingURL=TabTrigger.js.map
